

class Op3_calc {
	broj_katova = null;
	broj_dijelova = null;
	pre_pb = null;
	
	constructor() {
		// nothing for now
	}

	setValues(broj_katova, broj_dijelova, pre_pb) {
		this.broj_katova = broj_katova !== null && broj_katova !== undefined ? broj_katova : this.broj_katova;
		this.broj_dijelova = broj_dijelova !== null && broj_dijelova !== undefined ? broj_dijelova : this.broj_dijelova;
		this.pre_pb = pre_pb !== null && pre_pb !== undefined ? pre_pb : this.pre_pb;
	}

	resetValues() {
		this.broj_katova = null;
		this.broj_dijelova = null;
		this.pre_pb = null;
	}

	renderValues() {
		if (this.broj_katova !== null) {
			const brojKatova = document.getElementById('op3-chip-broj-katova');
			brojKatova.lastElementChild.innerText = this.broj_katova;
		}
		if (this.broj_dijelova !== null) {
			const brojDijelova = document.getElementById('op3-chip-broj-dijelova');
			brojDijelova.lastElementChild.innerText = this.broj_dijelova;
		}
		if (this.prePb !== null) {
			const prePb = document.getElementById('op3-chip-pre-pb');
			prePb.lastElementChild.innerText = this.pre_pb;
		}
	}
}

export default Op3_calc;